import { compare, validate } from 'compare-versions';
import { addMilliseconds, startOfTomorrow } from 'date-fns';

const NIGHTLY_CHECK_WINDOW_MS = 4 * 60 * 60 * 1000; // 4 hours in milliseconds

export type AppMeta = {
  version?: string;
  minVersion?: string;
};

/**
 * Tells whether the running bundle must be reloaded: right away when it is older than `minVersion`,
 * and at the nightly check when the deployed `version` differs from it.
 */
export const shouldReloadApp = (currentVersion: string, meta: AppMeta, isNightlyCheck: boolean): boolean => {
  if (meta.minVersion && validate(meta.minVersion) && compare(currentVersion, meta.minVersion, '<')) {
    return true;
  }

  return isNightlyCheck && !!meta.version && meta.version !== currentVersion;
};

/**
 * Picks a random moment within the first hours after the next local midnight, so that the open tabs
 * spread their nightly reload instead of all rebooting the app at the same second.
 */
export const getNightlyCheckAt = (): Date =>
  addMilliseconds(startOfTomorrow(), Math.floor(Math.random() * NIGHTLY_CHECK_WINDOW_MS));
